import React from 'react';
import DocumentsTableSC from './documents-table.styled';
import { ReactComponent as FileIcon } from '../../../assets/img/svg/pdf.svg';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { EmptySC } from '../investor-mailbox-content.styled';
import { LS_ACCESS_TOKEN } from '../../../constants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { Pagination } from '../../ui';
import useInlinePagination from '../../../utils/hooks/useInlinePagination';
import InlineLoading from '../../ui/inline-loading';

const DocumentsTable = ({ documents, getMailboxDocuments, loading }) => {
  React.useEffect(() => {
    getMailboxDocuments();
  }, [getMailboxDocuments]);

  const {
    slicedData,
    paginationConfig,
    onChange: handlePaginationChange,
    onPageSizeChange,
  } = useInlinePagination(documents);

  const onDocumentClick = (docLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${docLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
  };

  if (documents.length < 1) {
    return (
      <EmptySC>
        <div className="empty-table">
          {loading ? (
            <InlineLoading />
          ) : (
            <SmallText className="black-transparent bold">
              <FormattedMessage
                id="mailbox_documents_empty"
                defaultMessage={dlt['mailbox_documents_empty']}
              />
            </SmallText>
          )}
        </div>
      </EmptySC>
    );
  }

  return (
    <DocumentsTableSC>
      {slicedData.map((doc) => {
        return (
          <div key={doc.id} className="doc-wrap">
            <button onClick={() => onDocumentClick(doc.url)}>
              <span className="doc-icon">
                <FileIcon />
              </span>
              <div className="doc-info-wrap">
                <span className="doc-name">
                  <BodyText>{doc.name}</BodyText>
                  {doc.investment_id ? (
                    <SmallText className="black-transparent">
                      <FormattedMessage
                        id="mailbox_table_investment"
                        defaultMessage={dlt['mailbox_table_investment']}
                      />
                      : {doc.investment_id}
                    </SmallText>
                  ) : null}
                </span>
                <span className="doc-date">
                  <BodyText className="black-transparent" style={{ whiteSpace: 'nowrap' }}>
                    <Moment format="DD. MMMM YYYY">{doc.created_at}</Moment>
                  </BodyText>
                  <BodyText className="black-transparent">
                    <Moment format="HH:mm">{doc.created_at}</Moment>
                  </BodyText>
                </span>
              </div>
            </button>
          </div>
        );
      })}
      {documents.length > 0 && (
        <div className="pagination-wrap">
          <Pagination
            pagination={paginationConfig}
            onChange={handlePaginationChange}
            onPageSizeChange={onPageSizeChange}
          />
        </div>
      )}
    </DocumentsTableSC>
  );
};

const mapStateToProps = (state) => {
  return {
    documents: state.mailbox.documents,
    loading: state.mailbox.documentsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getMailboxDocuments: ActionCreators.getMailboxDocuments,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsTable);
